import { Done } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useCallback, useMemo } from "react";
import { AppTheme } from "theme";
import { MessageVariant } from "./types";

interface IProps {
  variant: MessageVariant;
  date: Date;
  delivered?: boolean;
  read?: boolean;
}

export default function MessageStatus(props: IProps) {
  const {
    variant,
    date,
    delivered = false,
    read = false,
  } = props;

  const timeString = useMemo(() => {
    const now = new Date();

    const isToday =
      date.getFullYear() === now.getFullYear() &&
      date.getMonth() === now.getMonth() &&
      date.getDate() === now.getDate();

    const timeString = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    const dataString = date.toLocaleDateString([], {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })

    if (isToday) {
      return timeString
    }

    return `${dataString} ${timeString}`;
  }, [date]);

  const statusColor = useCallback((done: boolean) => {
    return done ? {
      color: AppTheme.buttonBg,
      '@media (prefers-color-scheme: dark)': {
        color: AppTheme.buttonBgDark,
      }
    } : {
      color: grey[500],
    };
  }, [])

  return (
    <Box sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: variant === "out" ? "flex-end" : "flex-start",
      gap: 0.5,
    }}>
      <Typography
        variant={"caption"}
        sx={{
          opacity: 0.6,
        }}
      >{timeString}</Typography>
      {variant === "out" && (
        <Box>
          <Box sx={{
            width: "1em",
            height: "1em",
            position: "relative",
          }}>
            <Done
              sx={{
                ...statusColor(delivered),
                display: "block",
                position: "absolute",
                top: 0,
                left: "-11%",
                width: "100%",
                height: "100%",
              }}
            />
            <Done
              sx={{
                ...statusColor(read),
                display: "block",
                position: "absolute",
                top: 0,
                right: "-11%",
                width: "100%",
                height: "100%",
              }}
            />
          </Box>
        </Box>
      )}
    </Box>
  )
}